'use strict';

var AlgoliaSearchCore = require('../../AlgoliaSearchCore.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearchCore, '(lite) ');



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/builds/algoliasearchLite.js
// module id = 6
// module chunks = 0